/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Gap_AllowedInputs */

const en_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum gap allowed between frames`)
};

const fr_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart minimum autorisé entre les images`)
};

const de_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestabstand zwischen den Bildern`)
};

const it_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio minimo consentito tra i telai`)
};

const ru_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимально допустимый зазор между рамками`)
};

const es_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio mínimo permitido entre marcos`)
};

const zh_cn2_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧之间允许的最小间隙`)
};

const ja_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム間の最小許容ギャップ`)
};

const hi_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेमों के बीच न्यूनतम अनुमत अंतराल`)
};

const pt_pt2_minimum_gap_allowed = /** @type {(inputs: Minimum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço mínimo permitido entre quadros`)
};

/**
* | output |
* | --- |
* | "Minimum gap allowed between frames" |
*
* @param {Minimum_Gap_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_gap_allowed = /** @type {((inputs?: Minimum_Gap_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Gap_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_minimum_gap_allowed(inputs)
	if (locale === "de") return de_minimum_gap_allowed(inputs)
	if (locale === "it") return it_minimum_gap_allowed(inputs)
	if (locale === "ru") return ru_minimum_gap_allowed(inputs)
	if (locale === "es") return es_minimum_gap_allowed(inputs)
	if (locale === "zh-CN") return zh_cn2_minimum_gap_allowed(inputs)
	if (locale === "ja") return ja_minimum_gap_allowed(inputs)
	if (locale === "hi") return hi_minimum_gap_allowed(inputs)
	if (locale === "pt-PT") return pt_pt2_minimum_gap_allowed(inputs)
	return en_minimum_gap_allowed(inputs)
});